import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CandidateExtraInfo } from '@shared/models/candidate-extra-info';
import { createReducer, on } from '@ngrx/store';
import { candidatesExtraInfoLoadSuccess } from '@modules/candidate-extra-info/store/candidate-extra-info.actions';

export interface CandidateExtraInfoState extends EntityState<CandidateExtraInfo> {
  extraInfoList: CandidateExtraInfo[];
}

export const candidateExtraInfoAdapter: EntityAdapter<CandidateExtraInfo> =
  createEntityAdapter<CandidateExtraInfo>({});

export const initialState: CandidateExtraInfoState = candidateExtraInfoAdapter.getInitialState({
  extraInfoList: [],
});

export const candidateExtraInfoReducer = createReducer(
  initialState,
  on(candidatesExtraInfoLoadSuccess, (state, { payload }) => ({
    ...state,
    extraInfoList: [...payload, ...state.extraInfoList].filter(
      (value, index, self) =>
        self.findIndex(
          (selfValue) =>
            selfValue.candidateId === value.candidateId && selfValue.question === value.question,
        ) === index,
    ),
  })),
);
